const styles = theme => ({

    mainGrid:{
        margin: "7% 0 0 2% !important", 
        width:'100% !important',
    },

    textGrid:{
        margin:'0px 0px 50px 0px !important'
    },

    campaignText: {
        color: '#FFF ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '34px ! important',
        fontStyle: 'normal',
        fontWeight: '500 ! important',
        lineHeight: '20px ! important'
    },

})

export default styles